import {
  normalizeCategory,
  normalizeListingType,
  getKind,
  getListingBadge,
  getTypeLabel,
  getConfigLabel,
  formatArea,
  formatIndianNumber,
  getPriceUnit,
  getOptionLabel,
  toNumber,
} from "../shared/listingRules";

/** Which transaction pill a listing belongs to, legacy values included. */
export function getListingTypeOf(listing) {
  return normalizeListingType(listing?.category || listing?.listingType, listing?.propertyCategory);
}

export function getListingStatus(listing) {
  return listing?.status || "active";
}

/**
 * Everything a list card shows, labelled exactly as the app labels it:
 * "For Lease" (never "Buy/Sell"), "2 BHK" only for homes, sq ft / sq yd
 * areas, Indian digit grouping and the price unit for the transaction.
 */
export function getListingCardInfo(listing) {
  const p = listing || {};
  const category = normalizeCategory(p.propertyCategory) || "residential";
  const listingType = getListingTypeOf(p);
  const kind = getKind(category, p.propertyType);
  const price = toNumber(p.price);
  const bathrooms = kind === "home" && toNumber(p.bathrooms) > 0 ? toNumber(p.bathrooms) : null;
  const status = getListingStatus(p);

  return {
    category,
    listingType,
    kind,
    badge: getListingBadge(listingType, category) || "Listed",
    badgeClass: listingType || "default",
    typeLabel: getTypeLabel(p.propertyType, category, true),
    configLabel: getConfigLabel(p),
    areaLabel: formatArea(p),
    bathroomsLabel: bathrooms ? `${bathrooms >= 4 ? "4+" : bathrooms} Bath` : "",
    priceLabel: price !== null && price > 0 ? `₹${formatIndianNumber(price)}` : "Price on request",
    priceUnit: price !== null && price > 0 ? getPriceUnit(listingType || "buy", kind) : "",
    status,
    statusLabel: status === "active" ? "" : getOptionLabel("listingStatuses", status),
  };
}
